import React, {useState, memo} from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

//components:
import Fade from "@material-ui/core/Fade";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import useInfo from "./useInfo";

const useStyles = makeStyles(theme => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        borderRadius: "0.5rem",
        boxShadow: theme.shadows[5],
    },
    stepperRoot: {
        flexGrow: 1,
        marginTop: "auto",
        backgroundColor: "white",
    },
}));

export const CustomInfoModalWithPagination = memo(
    ({open, setOpen, type}) => {
        const {t} = useTranslation();
        const classes = useStyles();
        const theme = useTheme();

        const [activeStep, setActiveStep] = useState(0);

        const slides = useInfo(type) || [];

        const handleNext = () => {
            setActiveStep(prevActiveStep => prevActiveStep + 1);
        };

        const handleBack = () => {
            setActiveStep(prevActiveStep => prevActiveStep - 1);
        };

        return (
            <Fade in={open}>
                <div className="custom-info-modal custom-info-modal-multipage">
                    <div
                        className="dark_overlay_modal"
                        onClick={() => {
                            setOpen(false);
                        }}
                    />
                    <div className={`customModal ${classes.paper}`}>
                        {slides && slides.length ? (
                            <div className="content">
                                <button
                                    type="button"
                                    className="close position-absolute top-0 right-0"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setOpen(false)}
                                >
                                    <HighlightOffRoundedIcon fontSize="large" />
                                </button>
                                <div
                                    className={`d-flex flex-column justify-content-${slides[activeStep].align} h-100 w-100`}
                                >
                                    {slides[activeStep].icon ? <i className={`${slides[activeStep].icon}`} /> : null}

                                    <h3
                                        dangerouslySetInnerHTML={{
                                            __html: slides[activeStep].titleTag,
                                        }}
                                        className={` ${
                                            slides[activeStep].icon || slides[activeStep].descriptionTag
                                                ? "mb-7"
                                                : "m-auto"
                                        }`}
                                    />

                                    {slides[activeStep].descriptionTag ? (
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: slides[activeStep].descriptionTag,
                                            }}
                                        />
                                    ) : null}

                                    {slides[activeStep].gif ? (
                                        <iframe
                                            title="iframe"
                                            src={slides[activeStep].gif}
                                            frameBorder="0"
                                            allow="autoplay; fullscreen"
                                            allowFullScreen
                                        />
                                    ) : null}

                                    {slides[activeStep].img ? (
                                        <img src={slides[activeStep].img} alt="modalImg" />
                                    ) : null}
                                </div>
                            </div>
                        ) : null}

                        <MobileStepper
                            variant="dots"
                            steps={slides && slides.length}
                            position="static"
                            activeStep={activeStep}
                            className={classes.stepperRoot}
                            nextButton={
                                <Button size="small" onClick={handleNext} disabled={activeStep === slides.length - 1}>
                                    {t("GENERAL.NEXT")}
                                    {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                                </Button>
                            }
                            backButton={
                                <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                                    {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                                    {t("GENERAL.BACK")}
                                </Button>
                            }
                        />
                    </div>
                </div>
            </Fade>
        );
    },
    (prevProps, nextProps) =>
        prevProps.open === nextProps.open &&
        prevProps.setOpen === nextProps.setOpen &&
        prevProps.type === nextProps.type
);

CustomInfoModalWithPagination.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    type: PropTypes.string,
};
